import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

const Playground = lazy(() => import("../playground/Playground"));

export const developmentRoutes: RouteObject[] = [
	{
		path: ROUTES.PLAYGROUND,
		element: protectedRoute(<Playground />),
	},
];
